import React, { useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Navbar, Container, Nav, NavDropdown } from 'react-bootstrap';
import { FaMoneyBillWave, FaKey } from 'react-icons/fa';
import AuthContext from '../../context/AuthContext';
import { useLicense } from '../../context/LicenseContext';
import LicenseStatus from '../license/LicenseStatus';

const Header = () => {
  const { isAuthenticated, user, logout } = useContext(AuthContext);
  const { isLicenseValid, getDaysRemaining } = useLicense();
  const navigate = useNavigate();

  const onLogout = () => {
    logout();
    navigate('/');
  };

  const adminLinks = (
    <>
      <Nav.Link as={Link} to="/admin/dashboard">Dashboard</Nav.Link>
      <Nav.Link as={Link} to="/admin/customers">Customers</Nav.Link>
      <NavDropdown title="Management" id="admin-dropdown">
        <NavDropdown.Item as={Link} to="/admin/customers/create">Create Customer</NavDropdown.Item>
        <NavDropdown.Item as={Link} to="/admin/users">Users</NavDropdown.Item>
        <NavDropdown.Item as={Link} to="/admin/users/create">Create User</NavDropdown.Item>
      </NavDropdown>
    </>
  );

  const customerLinks = (
    <>
      <Nav.Link as={Link} to="/dashboard">Dashboard</Nav.Link>
      <Nav.Link as={Link} to="/projects">Projects</Nav.Link>
      <Nav.Link as={Link} to="/clients">Clients</Nav.Link>
      <Nav.Link as={Link} to="/employees">Employees</Nav.Link>
      <Nav.Link as={Link} to="/payments"><FaMoneyBillWave className="me-1" /> Payments</Nav.Link>
      <Nav.Link as={Link} to="/reports">Reports</Nav.Link>
      <NavDropdown title="Actions" id="customer-dropdown">
        <NavDropdown.Item as={Link} to="/projects/create">Create Project</NavDropdown.Item>
        <NavDropdown.Item as={Link} to="/clients/create">Create Client</NavDropdown.Item>
        <NavDropdown.Item as={Link} to="/employees/create">Create Employee</NavDropdown.Item>
        <NavDropdown.Divider />
        <NavDropdown.Item as={Link} to="/license">
          <FaKey className="me-1" /> License Management
        </NavDropdown.Item>
      </NavDropdown>
    </>
  );

  const authLinks = (
    <>
      <Nav className="me-auto">
        {user?.isAdmin ? adminLinks : customerLinks}
      </Nav>
      <Nav>
        {/* License Status - only show for customers */}
        {!user?.isAdmin && isAuthenticated && (
          <div className="d-none d-lg-block me-3 pt-2">
            <LicenseStatus showDetailed={false} />
          </div>
        )}
        <NavDropdown title={user?.Username || 'User'} id="user-dropdown">
          {!user?.isAdmin && (
            <>
              <NavDropdown.Item as={Link} to="/license">
                <FaKey className="me-1" /> License Status
              </NavDropdown.Item>
              <NavDropdown.Divider />
            </>
          )}
          <NavDropdown.Item onClick={onLogout}>Logout</NavDropdown.Item>
        </NavDropdown>
      </Nav>
    </>
  );

  const guestLinks = (
    <Nav className="ms-auto">
      <Nav.Link as={Link} to="/">Login</Nav.Link>
      <Nav.Link as={Link} to="/admin">Admin Login</Nav.Link>
    </Nav>
  );

  return (
    <Navbar bg="dark" variant="dark" expand="lg">
      <Container>
        <Navbar.Brand as={Link} to={isAuthenticated ? (user?.isAdmin ? '/admin/dashboard' : '/dashboard') : '/'}>
          Construction Management System
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          {isAuthenticated ? authLinks : guestLinks}
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Header;
